import { useFormik } from "formik";
import React, { useEffect, useState, useCallback } from "react";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { io } from "socket.io-client";
import checkIcon from "../../../assets/icons/check-green.svg";
import { route } from "../../../services/apiRoutes";
import Loader from "../../../components/Loader";
import {
  Grid,
  FormHelperText,
  Button,
  Box,
  Typography,
  Divider,
  debounce,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import TextFieldInput from "../../../components/TextFieldInput";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import { BOOKING_FORM_STATUS, ERROR_MESSAGE, OWNER_TYPE, RESIDING_AS } from "../../../config/constant";
import SignaturePopup from "../../../shared-components/signature-popup/SignaturePopup";
import TermsAndConditionReferralForm from "./TermsAndConditionReffererForm";
import GetAppIcon from "@mui/icons-material/GetApp";
import { RHFPhoneInput } from "../../../shared-components/phone-input/RHFPhoneInput";
import { isValidPhoneNumberWithRules, removeBlobImages } from "../../../utilis/common-funtions";
import GoogleMapsAutocomplete from "../../../shared-components/google-maps-autocomplete/GoogleMapsAutocomplete";
import UploadPopup from "../../../shared-components/upload-popup/UploadPopup";
import UploadInput from "../../../components/UploadInput";
import { getApplicantDetails, setIsLoading, updateReferralDetails } from "../../new-booking-form/new-booking-form.slice";

const { REACT_APP_S3_BASE_URL, REACT_APP_SOCKET_SERVER_URL } = process.env;

let windowPopup = "";

const ReferrerDetails = ({ handleActiveStep }) => {
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const [signInData, setSignInData] = useState({ link: null, isActive: null });
  const [socket, setSocket] = useState();
  const [signUserStatus, setSignUserStatus] = useState([]);
  const [acceptTermsAndCondition, setAcceptTermsAndCondition] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const { offline } = useSelector((state) => state.newBookingForm);
  const dispatch = useDispatch();
  const { oppId } = useParams();
  const { enquiryDetails, isLoading, applicantData } = useSelector(
    (state) => state?.newBookingForm
  );

  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [showUploadPopup, setShowUploadPopup] = useState({
    showUploadSaleDeedDocument: false,
    showUploadRentalAgreement: false,
  });

  const handleImageValue = (keyName, imgName) => {
    removeBlobImages();
    referrerDetailsFormik.setFieldValue(keyName, imgName);
  };



  useEffect(() => {
    if (
      applicantData?.referrerDetails?.signedStatus ===
        BOOKING_FORM_STATUS?.SIGNED ||
      applicantData?.referrerDetails?.signedStatus ===
        BOOKING_FORM_STATUS?.SIGNED_OFFLINE ||
      signUserStatus?.referrerDetails?.signedStatus ===
        BOOKING_FORM_STATUS?.SIGNED || 
      applicantData?.referrerDetails?.signedStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE ||
       applicantData?.referrerDetails?.isSignedOffline ||
       offline 
    ) {
      setFormSubmitted(true);
    } else {
      setFormSubmitted(false);
    }
  }, [applicantData, signUserStatus?.referrerDetails?.signedStatus]);


  const validationSchema = yup.object({
    name: yup.string().required("Name of the Referrer​ is required"),
    relation: yup.string().required("Relationship with referrer is required"),
    address: yup
      .string()
      .required("Enter Property, Area or Street Name is required"),
    mobileNumber: yup
      .string()
      .required("Contact Number of the Referrer is required")
      .test("is-valid-phone", "Contact Number is invalid", (value, context) => {
        const { mobileNumber, countryCode } = context.parent;
        if (!value || !countryCode) return false;
        return isValidPhoneNumberWithRules(countryCode, mobileNumber);
      }),
    email: yup
      .string()
      .matches(
        /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Please enter a valid email address"
      )
      .required("Email of the Referrer is required"),
    houseNumber: yup.string().required("House Number/Floor is required"),
    saleDeedDocument: yup
      .array()
      .nullable()
      .when(['ownerType', 'isPhysicalSaleDeedDocument'], {
        is: (ownerType, isPhysicalSaleDeedDocument) =>
          ownerType === OWNER_TYPE.SECONDARY && isPhysicalSaleDeedDocument === false,
        then: (schema) =>
          schema
            .min(1, 'Sale Deed Document is required')
            .required('Sale Deed Document is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    rentalAgreement: yup
      .array()
      .nullable()
      .when(['residingAs', 'isPhysicalRentalAgreement'], {
        is: (residingAs, isPhysicalRentalAgreement) =>
          residingAs === RESIDING_AS.TENANT && isPhysicalRentalAgreement === false,
        then: (schema) =>
          schema
            .min(1, 'Rental Agreement is required')
            .required('Rental Agreement is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

  });

  const referrerDetailsFormik = useFormik({
    initialValues: {
      name: "",
      relation: "",
      unitNumber: "",
      propertyName: "",
      email: "",
      countryCode: "IN",
      mobileNumber: "",
      address: "",
      houseNumber: "",
      residingAs: "",
      ownerType: "",
      saleDeedDocument: [],
      rentalAgreement: [],
      isPhysicalSaleDeedDocument: false,
      isPhysicalRentalAgreement: false,
    },
    validationSchema,
  });

  const debouncedValidate = useCallback(
    debounce(() => {
      referrerDetailsFormik.validateForm();
    }, 300),
    []
  );
  useEffect(() => {
    let obj = {
      name: "",
      relation: "",
      unitNumber: "",
      propertyName: "",
      email: "",
      countryCode: "",
      mobileNumber: "",
      address: "",
      houseNumber: "",
      refereeName: "",
      refereeProjectName: "",
      refereeUnitNo: "",
      tower: "",
      residingAs: "",
      ownerType: "",
      saleDeedDocument: [],
      rentalAgreement: [],
      isPhysicalSaleDeedDocument: false,
      isPhysicalRentalAgreement: false,
    };

    if (applicantData && applicantData?.referrerDetails !== null) {
      obj = {
        name: applicantData?.referrerDetails?.name || "",
        relation: applicantData?.referrerDetails?.relation || "",
        unitNumber: applicantData?.referrerDetails?.unitNumber || "",
        propertyName: applicantData?.referrerDetails?.propertyName || "",
        email: applicantData?.referrerDetails?.email || "",
        countryCode: applicantData?.referrerDetails?.countryCode || "",
        mobileNumber: applicantData?.referrerDetails?.mobileNumber || "",
        address: applicantData?.referrerDetails?.address || "",
        houseNumber: applicantData?.referrerDetails?.houseNumber || "",
        refereeName:
          `${applicantData?.applicant1?.personalDetails?.firstName || ""} ${applicantData?.applicant1?.personalDetails?.lastName || ""}`.trim(),
        refereeProjectName: applicantData?.unitDetails?.projectName || enquiryDetails?.data?.ProjectName || "",
        refereeUnitNo: applicantData?.unitDetails?.unitNumber || enquiryDetails?.data?.UnitNo || "",
        tower: applicantData?.referrerDetails?.tower || enquiryDetails?.data?.tower || "",
        residingAs: applicantData?.referrerDetails?.residingAs || enquiryDetails?.data?.residingAs || "",
        ownerType: applicantData?.referrerDetails?.ownerType || enquiryDetails?.data?.ownerType || "",
        saleDeedDocument: applicantData?.referrerDetails?.saleDeedDocument || enquiryDetails?.data?.saleDeedDocument || [],
        isPhysicalSaleDeedDocument: applicantData?.referrerDetails?.isPhysicalSaleDeedDocument || enquiryDetails?.data?.isPhysicalSaleDeedDocument || false,
        rentalAgreement: applicantData?.referrerDetails?.rentalAgreement || enquiryDetails?.data?.rentalAgreement || [],
        isPhysicalRentalAgreement: applicantData?.referrerDetails?.isPhysicalRentalAgreement || enquiryDetails?.data?.isPhysicalRentalAgreement || false,
      };
    } else if (enquiryDetails && enquiryDetails?.data) {
      obj.unitNumber = enquiryDetails?.data?.UnitNumber || "";
      obj.propertyName = enquiryDetails?.data?.PropoertyName || "";
      obj.name = enquiryDetails?.data?.OppName || "";
      obj.mobileNumber = enquiryDetails?.data?.MobileNumber || "";
      obj.countryCode = enquiryDetails?.data?.MobileNumber ? "+91" : "";
      obj.refereeName = `${applicantData?.applicant1?.personalDetails?.firstName || ""} ${applicantData?.applicant1?.personalDetails?.lastName || ""}`.trim();
      obj.refereeProjectName = applicantData?.unitDetails?.projectName || enquiryDetails?.data?.ProjectName || "";
      obj.refereeUnitNo = applicantData?.unitDetails?.unitNumber || enquiryDetails?.data?.UnitNo || "";
      obj.tower = applicantData?.referrerDetails?.tower || enquiryDetails?.data?.tower || "";
      obj.residingAs = applicantData?.referrerDetails?.residingAs || enquiryDetails?.data?.residingAs || "";
      obj.ownerType = applicantData?.referrerDetails?.ownerType || enquiryDetails?.data?.ownerType || "";
      obj.saleDeedDocument = applicantData?.referrerDetails?.saleDeedDocument || enquiryDetails?.data?.saleDeedDocument || [];
      obj.isPhysicalSaleDeedDocument = applicantData?.referrerDetails?.isPhysicalSaleDeedDocument || enquiryDetails?.data?.isPhysicalSaleDeedDocument || false;
      obj.rentalAgreement = applicantData?.referrerDetails?.rentalAgreement || enquiryDetails?.data?.rentalAgreement || [];
      obj.isPhysicalRentalAgreement = applicantData?.referrerDetails?.isPhysicalRentalAgreement || enquiryDetails?.data?.isPhysicalRentalAgreement || false;
    }

    referrerDetailsFormik.setValues(obj);
    debouncedValidate();
  }, [applicantData, enquiryDetails, debouncedValidate]);

  useEffect(() => {
    referrerDetailsFormik.validateForm();
  }, [referrerDetailsFormik.values]);

  useEffect(() => {
    if (referrerDetailsFormik.values?.ownerType === OWNER_TYPE.PRIMARY) {
      referrerDetailsFormik.setFieldValue("saleDeedDocument", "");
      referrerDetailsFormik.setFieldValue("isPhysicalSaleDeedDocument", false);
    }
  }, [referrerDetailsFormik.values?.ownerType]);

  const handleSaveForm = async (type) => {
    try {
      const errors = await referrerDetailsFormik.validateForm();
      if (Object.keys(errors).length === 0) {
        dispatch(setIsLoading(true));

        const payload = { ...referrerDetailsFormik.values };

        const res = await dispatch(
          updateReferralDetails({
            path: `${route.UPDATE_REFERRER_DETAILS}/${oppId}`,
            payload: payload,
            opportunityId: oppId,
          })
        ).unwrap();

        if (res?.statusCode === 200) {
          setOpenSignatureModal(true);
        }
      }
    } catch (error) {
      setSnackbarConfig({
        open: true,
        message: ERROR_MESSAGE,
        severity: "error",
      });
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    connect();
  }, []);

  function connect() {
    // const socketClient = io("http://purv-ws.iprotec.in", {
    //   path: "booking_events", // Set the path without a leading or trailing slash
    //   query: { oppId: oppId },
    //   transports: ["websocket"],
    //   // timeout: 10000, // 20 seconds (increase as needed)
    // });
    const socketClient = io(`${REACT_APP_SOCKET_SERVER_URL}?oppId=${oppId}`);

    setSocket(socketClient);

    socketClient.on("connect", () => {
      console.log("Connected to WebSocket server.");
    });

    socketClient.on("connect_error", (error) => {
      console.log("Connection error:", error);
    });

    socketClient.on("disconnect", () => {
      console.warn("Disconnected from WebSocket server.");
    });

    socketClient.on("referrer_signed", (referrer_signed) => {
      setSignUserStatus(referrer_signed);

      if (windowPopup && !windowPopup.closed) {
        windowPopup.close();
        dispatch(getApplicantDetails(`/${oppId}`));
        windowPopup = "";
      }
    });

    return () => {
      socketClient.disconnect();
    };
  }

  useEffect(() => {
    let list = [];
    if (applicantData?.referrerDetails?.leegalityData?.invitees) {
      applicantData.referrerDetails.leegalityData.invitees.forEach(
        (item, i) => {
          if (item !== null) {
            list.push({
              name: item.name,
              value: i,
              link: item.signUrl, // Assuming this is the signing link
              isActive: false,
              email: item.email,
              isSigned: Boolean(applicantData.referrerDetails.leegalityData.documentId),
            });
          }
        }
      );
    }

    setSignInData({
      link: applicantData?.referrerDetails?.leegalityData?.invitees[0]?.signUrl,
      isActive:
        applicantData?.referrerDetails?.leegalityData?.invitees[0]?.active,
    });
    // setShowModal(true);
  }, [applicantData]);

  const handleSignatureModal = () => {
    setOpenSignatureModal(false);
  };

  const handleESignature = async () => {
    try {
      dispatch(setIsLoading(true));

      const payload = {
        ...applicantData?.referrerDetails,
        isSignedOffline: false,
      };

      const res = await dispatch(
        updateReferralDetails({
          path: `${route.UPDATE_REFERRER_DETAILS}/${oppId}`,
          payload,
          opportunityId: oppId,
        })
      ).unwrap();

      if (res?.statusCode === 200) {
        handleSignIn();
        setOpenSignatureModal(false);
      } else {
        setSnackbarConfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbarConfig({
        open: true,
        message: ERROR_MESSAGE,
        severity: "error",
      });
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const openWindow = (link) => {
    const url = link;
    const width = 1200;
    const height = 900;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    dispatch(getApplicantDetails(`/${oppId}`));
    windowPopup = window.open(
      url,
      "PopupWindow",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  const handleSignIn = async () => {
    dispatch(setIsLoading(true));
    try {
      openWindow(signInData?.link);
    } catch (error) {
      setSnackbarConfig({
        open: true,
        message: ERROR_MESSAGE,
        severity: "error",
      });
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const handleOffline = async () => {
    dispatch(setIsLoading(true));

    try {
      const payload = {
        ...applicantData?.referrerDetails,
        isSignedOffline: true,
      };

      const res = await dispatch(
        updateReferralDetails({
          path: `${route.UPDATE_REFERRER_DETAILS}/${oppId}`,
          payload: payload,
          opportunityId: oppId,
        })
      ).unwrap();

      if (res?.statusCode === 200) {
        setOpenSignatureModal(false);
      } else {
        setSnackbarConfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbarConfig({
        open: true,
        message: ERROR_MESSAGE,
        severity: "error",
      });
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const downloadPDF = () => {
    dispatch(getApplicantDetails(`/${oppId}`))
      .unwrap()
      .then((res) => {
        const finalName = "Referral_Form";
        const pdfUrl =
          REACT_APP_S3_BASE_URL +
          "/" +
          applicantData?.referrerDetails?.unsignedPdf;
        triggerDownload(pdfUrl, finalName);
      });
    const triggerDownload = async (url, pdfname) => {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      document.body.appendChild(a);
      a.download = `${pdfname}.pdf`;
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    };
  };

  const togglePopup = (type) => {
    removeBlobImages();

    const keyMap = {
      saleDeedDocument: "showUploadSaleDeedDocument",
      rentalAgreement: "showUploadRentalAgreement",
    };

    const key = keyMap[type];

    if (key) {
      setShowUploadPopup((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const handleUpdateImageData = (fieldName, imageData) => {
    referrerDetailsFormik.setFieldValue(fieldName, imageData);
  };

  const handlePhysicalImage = (fieldName, value) => {
    const fieldMap = {
      saleDeedDocument: "isPhysicalSaleDeedDocument",
      rentalAgreement: "isPhysicalRentalAgreement",
    };

    referrerDetailsFormik.setFieldValue(fieldMap[fieldName], value);
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box className="referralWrapper">
        <Box
          className="referralWrapper"
          sx={{
            border: " 1px solid #1A407D4D",
            padding: "26px 39px",
            borderRadius: "8px",
            mb: 2,
          }}
        >
          <Typography
            sx={{
              color: "#1C252E",
              textAlign: "center",
              fontSize: {
                md: "16px",
              },
              fontWeight: "600",
              lineHeight: {
                md: "22px",
              },
              mb: {
                md: "24px",
              },
            }}
          >
            Referrer Details
          </Typography>

          <form onSubmit={referrerDetailsFormik.handleSubmit} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "name",
                    label: "Name of the Referrer​",
                    placeholder: "Enter Name of the Referrer​",
                    required: true,
                    readonly: formSubmitted,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "relation",
                    label: "Relationship with Referrer",
                    placeholder: "Enter Relationship with Referrer",
                    required: true,
                    readonly: formSubmitted,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "propertyName",
                    label: "Project Name of the Referrer",
                    placeholder: "Enter Project Name of the Referrer",
                    required: true,
                    readonly: true,
                    maxLength: 100,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "unitNumber",
                    label: "Unit Number of the Referrer",
                    placeholder: "Enter Unit Number of the Referrer",
                    required: true,
                    readonly: true,
                    maxLength: 10,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "email",
                    label: "Email of the Referrer",
                    placeholder: "Enter Email of the Referrer",
                    required: true,
                    readonly: formSubmitted,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <RHFPhoneInput
                  name="mobileNumber"
                  countryCodeName="countryCode"
                  label="Contact Number of the Referrer"
                  country={referrerDetailsFormik?.values?.countryCode ?? "IN"}
                  formik={referrerDetailsFormik}
                  placeholder="Enter Contact Number of the Referrer"
                  required
                  showDialCode={true}
                />
              </Grid>

                <Grid item xs={12} md={6}>
                 <GoogleMapsAutocomplete
                name="address"
                formik={referrerDetailsFormik}
                label="Current Address of the Referrer"
                placeholder="Enter Address"
                variant="outlined"
                required={true}
                disabled={formSubmitted}
                TextFieldProps={{ size: "small" }}
              />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextFieldInput
                    field={{
                      name: "houseNumber",
                      label: "House Number/Floor",
                      required: true,
                      readonly: formSubmitted,
                      placeholder: "Enter House Number/Floor",
                      maxLength: 20,
                      value: referrerDetailsFormik?.values?.houseNumber,
                    }}
                    formik={referrerDetailsFormik}
                  />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "tower",
                    label: "Tower",
                    required: false,
                    readonly: false,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
               <Grid
                item
                xs={12}
                sx={{
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              />
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "residingAs",
                    label: "You are residing in Purva home as?",
                    required: false,
                    readonly: true,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              {referrerDetailsFormik?.values?.residingAs === RESIDING_AS.OWNER ?
                (
                  <>
                    <Grid item xs={12} sm={12} sx={{ pt: 0 }}>
                      <FormControl
                        component="fieldset"
                        error={referrerDetailsFormik.touched?.ownerType && !!referrerDetailsFormik.errors?.ownerType}
                        required
                      >
                        <RadioGroup
                          row
                          name="ownerType"
                          value={referrerDetailsFormik.values?.ownerType}
                          onChange={(e) => referrerDetailsFormik.setFieldValue("ownerType", e.target.value)}
                        >
                          <FormControlLabel
                            value={OWNER_TYPE.PRIMARY}
                            control={<Radio sx={{
                              color: '#1A407D',
                              '&.Mui-checked': {
                                color: '#1A407D',
                              },
                            }} />}
                            label="Primary Owner - Purchased from Puravankara"
                            sx={{
                              '& .MuiFormControlLabel-label': {
                                fontSize: '14px',
                              },
                            }}
                          />
                          <FormControlLabel
                            value={OWNER_TYPE.SECONDARY}
                            control={<Radio sx={{
                              color: '#1A407D',
                              '&.Mui-checked': {
                                color: '#1A407D',
                              },
                            }} />}
                            label="Secondary Owner - Bought on Resale"
                            sx={{
                              '& .MuiFormControlLabel-label': {
                                fontSize: '14px',
                              },
                            }}
                          />
                        </RadioGroup>

                        {referrerDetailsFormik.touched?.ownerType && referrerDetailsFormik.errors?.ownerType && (
                          <FormHelperText sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                            {referrerDetailsFormik.errors.ownerType}
                          </FormHelperText>
                        )}
                      </FormControl>

                    </Grid>

                    {referrerDetailsFormik?.values?.ownerType === OWNER_TYPE.SECONDARY &&
                      <>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: { xs: "none", sm: "none", md: "block" },
                          }}
                        />
                        <Grid item xs={12} sm={12} md={6}>
                          <UploadInput
                            field={{
                              name: "saleDeedDocument",
                              label: "Sale Deed Document",
                              placeholder: referrerDetailsFormik?.values?.isPhysicalSaleDeedDocument
                                ? "Submit Physical copy" : "Click to upload",
                              placeholderUpload: "Sale Deed Document Uploaded",
                              required: true,
                              handleOnClick: () => togglePopup("saleDeedDocument"),
                              physicalCopyValue:
                                referrerDetailsFormik.values?.isPhysicalSaleDeedDocument,
                            }}
                            formik={referrerDetailsFormik}
                          />
                          {showUploadPopup?.showUploadSaleDeedDocument && (
                            <UploadPopup
                              heading="Upload Sale Deed Document"
                              totalImages={1}
                              closePopup={() => togglePopup("saleDeedDocument")}
                              handleImageValue={handleImageValue}
                              uploadedImage={referrerDetailsFormik?.values?.saleDeedDocument}
                              fieldName={"saleDeedDocument"}
                              handleUpdateImageData={handleUpdateImageData}
                              handlePhysicalImage={handlePhysicalImage}
                              selectedOptionValue={
                                referrerDetailsFormik?.values?.isPhysicalSaleDeedDocument
                              }
                              dynamicSize={2}
                            />
                          )}
                        </Grid>
                      </>
                    }
                  </>
                )
                : referrerDetailsFormik?.values?.residingAs === RESIDING_AS.TENANT ? (
                  <>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: { xs: "none", sm: "none", md: "block" },
                      }}
                    />
                    <Grid item xs={12} sm={12} md={6}>
                      <UploadInput
                        field={{
                          name: "rentalAgreement",
                          label: "Rental Agreement",
                          placeholder: referrerDetailsFormik?.values?.isPhysicalRentalAgreement ? "Submit Physical Copy" : "Click to upload",
                          placeholderUpload: "Rental Agreement Uploaded",
                          required: true,
                          handleOnClick: () => togglePopup("rentalAgreement"),
                          physicalCopyValue:
                            referrerDetailsFormik.values?.isPhysicalRentalAgreement,
                        }}
                        formik={referrerDetailsFormik}
                      />
                      {showUploadPopup?.showUploadRentalAgreement && (
                        <UploadPopup
                          heading="Upload Rental Agreement"
                          totalImages={1}
                          closePopup={() => togglePopup("rentalAgreement")}
                          handleImageValue={handleImageValue}
                          uploadedImage={referrerDetailsFormik?.values?.rentalAgreement}
                          fieldName={"rentalAgreement"}
                          handleUpdateImageData={handleUpdateImageData}
                          handlePhysicalImage={handlePhysicalImage}
                          selectedOptionValue={
                            referrerDetailsFormik?.values?.isPhysicalRentalAgreement
                          }
                          dynamicSize={2}
                        />
                      )}
                    </Grid>
                  </>
                ): null
              }
            </Grid>
            <Divider
              sx={{
                borderStyle: "dashed",
                borderColor: "#D6D6D6",
                borderWidth: "1px",
                mt: "30px",
                mb: "16px",
              }}
            />
            <Typography
              sx={{
                color: "#1C252E",
                textAlign: "center",
                marginTop: "20px",
                fontSize: {
                  md: "16px",
                },
                fontWeight: "600",
                lineHeight: {
                  md: "22px",
                },
                mb: {
                  md: "24px",
                },
              }}
            >
              Referee Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "refereeName",
                    label: "Name",
                    required: false,
                    readonly: true,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "refereeProjectName",
                    label: "Project Name",
                    required: false,
                    readonly: true,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "refereeUnitNo",
                    label: "Unit No.",
                    required: false,
                    readonly: true,
                    maxLength: 50,
                  }}
                  formik={referrerDetailsFormik}
                />
              </Grid>
            </Grid>
            <TermsAndConditionReferralForm />
            <Divider
              sx={{
                borderStyle: "dashed",
                borderColor: "#D6D6D6",
                borderWidth: "1px",
                mt: "16px",
                mb: "24px",
              }}
            />

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#1A407D",
                marginBottom: "35px",
              }}
            >
              Declaration
            </Typography>
            <label className="checkTerms" style={{ marginTop: "50px" }}>
              &nbsp; I hereby declare that all the information provided by me
              above is true to the best of my knowledge and belief and I am
              submitting this registration form to avail the Purva Privileges
              benefits and I agree and shall abide by the terms and conditions
              specified above.
              <input
                onChange={(e) => setAcceptTermsAndCondition(e.target.checked)}
                checked={formSubmitted ? true : acceptTermsAndCondition}
                type="checkbox"
                disabled={formSubmitted}
              />
              <span className="checkmark"></span>
            </label>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "100%",
                },
                mt: {
                  xs: "20px",
                  sm: "40px",
                  md: "60px",
                },
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
              }}
            >
              {!applicantData?.referrerDetails?.isSignedOffline && (
                <Button
                  type="submit"
                  disabled={
                    formSubmitted
                      ? true
                      : !acceptTermsAndCondition
                  }
                  className={`${
                    signUserStatus?.email
                      ? "disableCTA"
                      : acceptTermsAndCondition
                      ? ""
                      : "disableCTA"
                  }`}
                  sx={{
                    width: "auto",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                    "&.Mui-disabled": {
                      background: "#eee",
                      color: "#ccc",
                    },
                  }}
                  onClick={() => {
                    handleSaveForm("save");
                  }}
                >
                  {referrerDetailsFormik?.values?.name
                    ? !formSubmitted
                      ? `Sign for ${referrerDetailsFormik?.values?.name}`
                      : `${referrerDetailsFormik?.values?.name} Signed`
                    : "Sign"}

                  {!formSubmitted ? null : (
                    <img src={checkIcon} alt="" style={{ marginLeft: "5px" }} />
                  )}
                </Button>
              )}
              {applicantData?.referrerDetails?.isSignedOffline && (
                <div
                  style={{ position: "block", Left: "0" }}
                  className="saveLater"
                  onClick={downloadPDF}
                >
                  <GetAppIcon className="svg" />
                  Download
                </div>
              )}
            </Box>
          </form>
        </Box>
      </Box>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
      {openSignatureModal && (
        <SignaturePopup
          closePopup={handleSignatureModal}
          handleESignature={handleESignature}
          handleOffline={handleOffline}
        />
      )}
    </>
  );
};

export default ReferrerDetails;
